import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../tokens.css";
import "./styles.css";
import "./theme.css";
import "./growth-redesign.css";
import "./learning-redesign.css";
import "./ui-reference-polish.css";
import "./ai-command-center.css";
import "./review-chronicle.css";
import "./finance-treasury.css";
import "./operational-pages.css";
import "./today-command.css";
import "./hillm-dark.css";
import "./work-hillm.css";
import "./finance-hillm.css";
import "./settings-hillm.css";
import "./misc-pages-hillm.css";
// 个人主线浅色工作区：只作用于今日 / 时间轴 / 目标与项目 / 工作系统 / 技能与兴趣。
import "./personal-mainline-light.css";
// 目标与项目页保持深色版本（用户指定：仅此页不回浅色），最后加载以覆盖浅色体系
import "./projects-hillm.css";
// 移动端适配修正（底部固定导航遮挡长列表内容）
import "./mobile-tweaks.css";
// 月度计划卡片：全部条目展示 + 列表区可上下拉动
import "./monthly-plan-scroll.css";
// 弹窗显示修复（.modal-sheet 缺 max-height/overflow → 底部被切且不能滚动）
import "./modal-fix.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// PWA service worker（仅生产环境，满足可安装要求）
if ("serviceWorker" in navigator && globalThis.__EARTH_ONLINE_BROWSER_TRIAL__ !== true) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* 忽略注册失败 */
    });
  });
}
